import React from 'react';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { Request, Notification, Util, runtime } from '../../common';
import { CircularProgress, Radio, Divider } from '@material-ui/core';
import Button, { MoreVert, GoCellLink, Link } from '../Button';
import { Cluster, UIComponent, mapClusterKey } from '../Base';
import SearchIcon from '@material-ui/icons/Search';
import Modal from '../Modal';
import Form, { FormAction } from '../Form';
import InfiniteScroll from "react-infinite-scroll-component";
import Backdrop, { Loading } from '../Backdrop';
import DataTable from './DataTable';
import DataList from './DataList';
import { findDOMNode } from 'react-dom';
import { Html } from '../Html';
import { getColumnField } from './Base';

function mapAlign(align) {
  switch (align) {
    case "left": return "start";
    case "right": return "end";
  }
  return align || "start";
}

export default class DataGrid extends UIComponent {

  constructor(props, context) {
    super(props, context);
  }

  selectMode(type) {
    return this.refs.core.selectMode(type);
  }

  getData() {
    return this.refs.core.getData();
  }

  get() {
    return this.refs.core.get();
  }

  set(items) {
    return this.refs.core.set(items);
  }

  reverseSet(items) {
    return this.refs.core.reverseSet(items);
  }

  reverseGet() {
    return this.refs.core.reverseGet();
  }

  reset() {
    return this.refs.core.reset();
  }

  renderColumn(data, column, i, go) {
    let { mobile, align, onClick } = column;
    if (!mobile) return;
    let { width, height, className, ellipsis } = mobile;
    align = mobile.align || align;
    onClick = mobile.onClick || onClick || go;
    width = width || "auto";
    ellipsis = ellipsis === false ? "" : "c-ellipsis";
    if (width == "full") width = "100%";
    align = mapAlign(align);
    let field = getColumnField(column);

    let render = column.component || mobile.component;

    return <div className={`d-flex justify-content-${align} align-items-center ${onClick ? 'c-pointer' : ''}`} key={i}
      onClick={onClick ? () => { onClick(data) } : null}
      style={{ width, height }}
      className={`c-text-s2 ${ellipsis} my-3 ${className || ''}`}>{render ? render(data) : data[field]}</div>
  }

  defaultRenderItem(data, columns, noLine, go) { //从列配置中提取可在移动端显示的数据
    return [
      <div key={0} className="d-flex flex-row justify-content-start align-items-center w-100">
        {
          columns.map((column, i) => {
            return this.renderColumn(data, column, i, go);
          })
        }
        {
          go ? this.renderColumn(data,
            {
              mobile: { width: "auto" }, align: "center", component: (row) => {
                return <GoCellLink className="h-100" color="primary" onClick={(e) => { e.stopPropagation(); go(row); }} />
              }
            }, columns.length, go) : null
        }
      </div>, noLine ? null : <Divider key={1} />
    ]
  }

  wrapperRenderItem(data, renderItem, noLine) { //从列配置中提取可在移动端显示的数据
    return [
      <div key={0} className="d-flex flex-row justify-content-start align-items-center w-100">
        {renderItem(data)}
      </div>, noLine ? null : <Divider key={1} />
    ]
  }

  load() {
    this.refs.core.load();
  }

  reload(arg) {
    this.refs.core.reload(arg);
  }

  table() {
    let p = { ...this.props };
    if (!p.columns && p.renderItem) {  //如果仅指定了renderItem，那么需要做一下转换
      let renderItem = p.renderItem;
      p.columns = [{
        disablePadding: true, component: (data, index) => {
          return renderItem(data, index)
        }
      }];

      delete p.renderItem;
    }

    return <DataTable ref="core" {...p} />;
  }

  repeater() {
    let p = { ...this.props, headers: false };
    return <DataTable ref="core" {...p} />;
  }

  render() {
    let { repeater } = this.props;
    return repeater ? this.repeater() : this.table();
  }

}

DataGrid.defaultProps = {
  className: '',
  pageSize: 25,
  emptyText: "暂无数据",
  page: true,
  mobile: { ellipsis: true },
}

DataGrid.modalClassName = runtime.mobile ? "py-2" : "py-4";


export class SearchBar extends React.Component {

  constructor(props) {
    super(props);

    this.searchMaster = mapClusterKey(this.props.searchMaster);
  }

  handleClick() {
    let { onClick } = this.props;
    var table = Cluster.getMaster(this.searchMaster);
    if (table) table.load();
    if (onClick) onClick(table.getParams());
  }

  renderButton() {
    let {mobileable} = this.props;
    if(runtime.mobile && mobileable) return; 
    return <div className={`ml-0`}>
      <Button color="cyan" shadow={0} onClick={() => { this.handleClick(); }}>搜索</Button>
    </div>
  }

  open() {
    this.refs.modal.open();
  }

  close() {
    this.refs.modal.close();
  }

  renderLeft() {
    let { children, hideButton } = this.props;
    return (
      <div className="d-flex flex-row justify-content-start align-items-center">
        {React.Children.map(children, (child, index) => {
          return child ? <div className={`mr-3`}>
            {child}
          </div> : null
        })}
        {hideButton ? null : this.renderButton()}
      </div>
    );
  }

  renderTools() {
    let { tools } = this.props;
    if (!tools) return null;
    return (
      <div className="d-flex flex-row justify-content-start align-items-center">
        {tools}
      </div>
    );
  }


  render() {
    let { className, face, view } = this.props;
    let extraClassName;
    if(face){
      extraClassName="shadow-xs c-l bg-white px-3 py-3 mt-0 mb-2";
    }else{
      if(runtime.mobile) {
        extraClassName="my-2";
      }else{
        extraClassName = "mt-2 mb-3";
      }
    }
    
    return (
      <div className={`c-searchBar d-flex flex-row justify-content-between align-items-center ${extraClassName} ${className}`}>
        {this.renderLeft()}
        {this.renderTools()}
        {view}
      </div>
    );
  }

}

SearchBar.defaultProps = {
  title: "搜索",
  className: "",
  mobileable:true
}

const SearchBox = ({ onClick }) => {
  return (
    <div className={`c-datatable-searchBox d-flex flex-row justify-content-center align-items-center w-100 p-1 mb-1 p-sm-2 mb-sm-2`} onClick={() => { onClick() }} >
      <SearchIcon className="c-icon-s2" />
      <font className="c-text-s1 ml-1">搜索</font>
    </div>
  )
};



export class DataCell extends React.Component {

  constructor(props) {
    super(props);
  }


  render() {
    let { children, className } = this.props;
    let p = { ...this.props };
    delete p.children; delete p.className;


    return (
      <div className={`row no-gutters w-100 ${className}`} {...p}>
        <div className="col-12">
          {children}
        </div>
      </div>
    )
  }

}

DataCell.defaultProps = {
  className: ''
}


export class DataFloor extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let { title, subtitle, tip, command, body, footer, className } = this.props;
    let p = { ...this.props };
    delete p.title; delete p.subtitle; delete p.tip; delete p.command; delete p.body; delete p.footer; delete p.children; delete p.className;

    return (
      <DataCell className={`c-pointer my-3 my-sm-4 px-0 px-sm-4 ${className}`} {...p}>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div className="d-flex flex-row align-items-center">
            {title ? (Util.type(title) === "string" ? <span className="text-dark c-text-s1 c-text-sm-s2 mr-2 font-weight-light">{title}</span> : title) : null}
            {subtitle ? <div className="d-none d-sm-block text-dark c-text-s1 c-text-sm-s2 font-weight-light">{subtitle}</div> : null}
          </div>
          <div className="d-flex flex-row align-items-center">
            {tip ? <div className="mr-2 d-block c-text-light-grey c-text-s1 c-text-sm-s2 font-weight-light">{tip}</div> : null}
            {command}
          </div>
        </div>
        <div className="d-sm-none d-flex flex-column">
          <div className="d-flex flex-row align-items-center my-1">
            {subtitle ? <div className="text-dark c-text-s1 c-text-sm-s2 font-weight-light">{subtitle}</div> : null}
          </div>
        </div>
        <div className="d-flex flex-column">
          {body ? <div className="mb-1 mt-1">{Util.type(body) == "string" ? <Html code={body} /> : body}</div> : null}
          {footer ? <div>{footer}</div> : null}
        </div>
      </DataCell>
    )
  }
}


DataFloor.defaultProps = {
  className: ''
}
